
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground } from 'docz'; 


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "alert-警告提示"
    }}>{`Alert 警告提示`}</h1>
    <p>{`警告提示，展现需要关注的信息。`}</p>
    <h2 {...{
      "id": "代码演示"
    }}>{`代码演示`}</h2>
    <h3 {...{
      "id": "基本用法"
    }}>{`基本用法`}</h3>
    <Playground __position={0} __code={'这是一条警告提示'} __scope={{
      props: this ? this.props : props,
      Playground
    }} __codesandbox={`N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPOhAG4AEE6AvADogAnSpQL8AfIwD0LVmJABfADQg0mXACsEyEFRp0CDSQCojvVO3YAVPBDjsAwpUwBlAIYYARpSzs8rux4wdOyuAK4ElESuBBDkrlBQAJ7sAOZ0MALRMOjsoXBoKWYWAAZUmHDu6F5YGcU47ACSYOyJlKEA5AIw7OShAhBtdniUAO7sBH4Evq4ADjPp6IotbT3uRT14MOQA1uxtU20C7OiU5EMZMIi-BAQzcIiSkikQE6EeOFREkmXwldXfTl-nm8GTM6yay1C7Gw836dHI3XcyTgBAEoRSKVgdhGLzw4xsdgqwKwSxmsH83UytkR5lscFCMHW1FSuLe9UQAEozEZJGYIEQZpQBFMAEowVzkKZgIREdidcWS9oAbj5AqFooVBAAIgB5ACy7GlkTlXQlBAAtCciMrVYLhQ5IoLUPpDTK5ThJNhXALYDbUGYxWbdXqcF0MBkABTrZhsMTrCyMPAAZjEjjVzponDVwuy7BxEx6gKJVRBAkQUmTcfMFnYjBmYgjDSmUWSztzrnQLBi1Hi7BmQju40oqRgUxe7DDmH6qBSeZgCQ5Unr8draadLskVYT0ljijMJ16RH0ODSBAAorAjzQAEKJBroCOdYQEdpc1AcpUKZRen0wHCaMgdGoWh6EQFRsymYB2AABSgVxEhSIRQgwdh5FdY12gPAAvP1-TtDUzXQ2V5TNdowVQXQUWOU4sOcAhEixdhuHYYB1iiARnlQK52gABnYJMZiwdo92rGYOxYGduIAFkE9gADZBOE9YwGAgAxb1oESbj-GcQ4EQdTAYKEfgliIahKDgMSESU6sVJoZwICwy52AARikkT5HIyipgAQTmJj2AjKDyBsKB0DDVCOSYsRAujGR2BRBiYG4YBsLopK4HkLca2AELoHC4IADJCvGRJ5koZo8rCiLuFquUwGQyUBlQdp2AAfg2fKwwjKKriqgrUE86spBkKs3zMGF1WOGAwDCKAph66LYuGvzl2rBNA0lHBVMyFIrwIMRAE34wB6M0AADlAENzQAzaMAKRVAAXjQAuTykTaCG23b9uyqRVrGswvxAKztlcNJ_zgahAN0ECDDA1jq34VBvUZJB2H4H5i2qDJzR_MkEZEix-FYDJ8mofgrn4HicDJniTPWfhynIfoZm7f1Ef4HyErw2BoSwb0semslKESXM8gKCdNXNFG_lLKmYZAKI0GJpGVHDDQ4Cl3GQEweZwwoiB4Hl6GawV7D5f4AA9FzyfJ1Wa34U1JWNkAzbknAXKTS2QBx63BFFq17cd53XcpkB1iG-RftR7wPmoSAUmB0HtHB_QGFYkBaB9LJieR01aHNW2LVmGZ-FD-Ri6AA`} mdxType="Playground">
  这是一条警告提示
    </Playground>
    <h2 {...{
      "id": "api"
    }}>{`API`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`属性`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`说明`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`类型`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`默认值`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`kind`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`警告类型`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`'info'/'positive'/'negative'/'warning'非必填`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`'info'`}</td>
        </tr>
      </tbody>
    </table>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;